<template>
  <div class="BusinessDetailsCenter main">
    <el-row class="content">
      <el-col>
        <el-row :xs="24" :sm="24" class="contentCenter" :gutter="0">
          <el-col :xs="24" :sm="18" class="contentLeft">
            <!-- 商家详情中部左侧 -->
            <div class="paddingGutter1">
              <BusinessDetailsCenterLeft
                :list="contentLeftList"
                :loginType="loginType"
                :msg="msg"
              />
            </div>
          </el-col>
          <el-col :xs="24" :sm="6" class="contentRight">
            <!-- 商家详情中部右侧 -->
            <div class="paddingGutter2">
              <BusinessDetailsCenterRight
                :loginType="loginType"
                :msg="msg"
              />
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- logoUrl: "../../../../public/static/images/IDG-logo.png", -->
  </div>
</template>

<script>
import BusinessDetailsCenterLeft from "@/components/DockingSystem/BusinessDetails/BusinessDetailsCenter_Left.vue"; //商家详情中部左侧
import BusinessDetailsCenterRight from "@/components/DockingSystem/BusinessDetails/BusinessDetailsCenter_Right.vue"; //商家详情中部左侧
export default {
  props: {
    loginType: Boolean, //登录状态,true为已登录
    msg:Object,
  },
  components: {
    BusinessDetailsCenterLeft,
    BusinessDetailsCenterRight,
  },
  data() {
    return {
      contentLeftList: ["项目介绍", "产品服务", "商业模式", "团队信息"],
 
    };
  },
  created: function () {},
  methods: {},
};
</script>

<style scoped>
@media (max-width: 768px) {
  .BusinessDetailsCenter .paddingGutter1{
      margin-left: 0px;
      margin-right: 0px;
  }
  .BusinessDetailsCenter .paddingGutter2{
      margin-left: 0px;
      margin-right: 0px;
      margin-top: 10px;
  }
}
.BusinessDetailsCenter {
  margin-top: 40px;
  padding-bottom: 40px;
}
.contentLeft {
  /* margin-right: 20px; */
  /* overflow: hidden; */
}
.contentRight {
  /* background-color: #1d1d1f; */
  /* padding-right: 0 !important; */
}
.paddingGutter1{
    /* padding:0 10px ; */
    margin-right: 10px;
}
.paddingGutter2{
    /* padding:0 10px ; */
    margin-left: 10px;
}
</style>